import { useEffect } from 'react'
import { Navigate, Outlet, useNavigate } from 'react-router-dom'
import { useAuthStore } from '@/store/auth-store'
import { isJwtExpired } from '@/utils/jwt'

export function AdminProtectedRoute() {
  const { isAuthenticated, user, accessToken, clearAuth } = useAuthStore()
  const navigate = useNavigate()

  const tokenExpired = isAuthenticated && accessToken != null && isJwtExpired(accessToken)

  useEffect(() => {
    if (tokenExpired) clearAuth()
  }, [tokenExpired, clearAuth])

  useEffect(() => {
    function handleSessionExpired() {
      clearAuth()
      navigate('/admin', { replace: true })
    }

    window.addEventListener('navega:session-expired', handleSessionExpired)
    return () => window.removeEventListener('navega:session-expired', handleSessionExpired)
  }, [clearAuth, navigate])

  if (!isAuthenticated || tokenExpired) return <Navigate to="/admin" replace />
  if (user?.userType !== 'navega_staff') return <Navigate to="/login" replace />

  return <Outlet />
}
